import React, { useContext } from 'react';
import { Switch, useRouteMatch } from 'react-router-dom';
import NavigationAidCreate from './create';
import NavigationAidEdit from './edit';
import NavigationAidCollection from './index';
import NavigationAidShow from './show';
import ClassificationsContext from '../common/ClassificationsContext';
import Page from '../common/Page';
import applicationConfigContext from '../common/application-config-context';
import ProtectedRoute from '../common/authorization/ProtectedRoute';
import { useAuthorization } from '../common/authorization/useAuthorization';

export default () => {
  const { operationalAreas, assetCategories } = useContext(
    ClassificationsContext
  );
  const config = useContext(applicationConfigContext);
  const auth = useAuthorization();
  const match = useRouteMatch();

  // If the user is not loaded yet, we can't check if they have permission to access the page.
  // We can't use the ProtectedRoute component because it will redirect the user to the unauthorized page
  // and won't bring them back to the page they were trying to access.
  if (auth.isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <Switch>
      <ProtectedRoute
        path={`${match.path}/new`}
        action="change_assets"
        redirectTo="/navigation_aids"
      >
        <NavigationAidCreate
          operationalAreas={operationalAreas}
          operationalBounds={config.operationalBounds}
          defaultPosition={config.defaultPosition}
          assetCategories={assetCategories}
        />
      </ProtectedRoute>
      <ProtectedRoute
        path={`${match.path}/:id/edit`}
        action="change_assets"
        redirectTo="/navigation_aids"
      >
        <NavigationAidEdit />
      </ProtectedRoute>
      <Page
        title="AtoN Summary"
        path={`${match.path}/:id`}
        component={NavigationAidShow}
      />
      <Page title="AtoNs" path={match.path}>
        <NavigationAidCollection
          operationalAreas={operationalAreas}
          assetCategories={assetCategories}
        />
      </Page>
    </Switch>
  );
};
